import types from "../actionTypes";
import * as apiServices from "../../services/apiServices";
import setLoaderAction from "./loaderAction";
import * as toastAction from "../actions/toastAction";
import { DEFAULT_ERROR_MESSAGE, ERROR_TIMEOUT,TOKEN_KEY } from "../../App.config";
import history from "../../utilities/history";
import { closeRemoveModal, openSetModal } from "./modalActions";

//functions 

function isOtpSend(IsOtpSend) {
    return {
        type: types.IS_OTP_SEND,
        IsOtpSend
    };
}

function setVerifyOtpData(otpData) {
    return {
        type: types.SET_OTP_DATA,
        otpData
    };
}
//export functions

    export const verifyEmailAddress = (email) => (dispatch) => {
        dispatch(setLoaderAction(true));
        return apiServices
            .verifyEmailAddress(email)
            .then(({ data }) => {
                if (data.isTransactionSucceed) {
                    dispatch(setLoaderAction(false));
                    // dispatch(setCompanyList(data.response));
                    dispatch(isOtpSend(true));
                    dispatch(toastAction.showSuccessMessage(true, data.successMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showSuccessMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    if (data.errorMessage) {
                        dispatch(setLoaderAction(false));
                        dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                        setTimeout(() => {
                            dispatch(toastAction.showErrorMessage(false, ""));
                        }, ERROR_TIMEOUT);
                    } else {
                        dispatch(setLoaderAction(false));
                        dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                        setTimeout(() => {
                            dispatch(toastAction.showErrorMessage(false, ""));
                        }, ERROR_TIMEOUT);
                    }
                }
            })
            .catch((error) => {
                dispatch(setLoaderAction(false));
                dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                setTimeout(() => {
                    dispatch(toastAction.showErrorMessage(false, ""));
                }, ERROR_TIMEOUT);
            });
    };

    export const verifyOtp = (email,otp) => (dispatch) => {
        dispatch(setLoaderAction(true));
        return apiServices
            .verifyOtp(email,otp)
            .then(({ data }) => {
                if (data.isTransactionSucceed) {
                    dispatch(setLoaderAction(false));
                    // dispatch(setCompanyList(data.response));
                    dispatch(setVerifyOtpData(data));
                    
                    localStorage.setItem(TOKEN_KEY,data.authToken);
                    dispatch(closeRemoveModal());
                    dispatch(toastAction.showSuccessMessage(true, data.successMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showSuccessMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    if (data.errorMessage) {
                        dispatch(setLoaderAction(false));
                        dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                        setTimeout(() => {
                            dispatch(toastAction.showErrorMessage(false, ""));
                        }, ERROR_TIMEOUT);
                    } else {
                        dispatch(setLoaderAction(false));
                        dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                        setTimeout(() => {
                            dispatch(toastAction.showErrorMessage(false, ""));
                        }, ERROR_TIMEOUT);
                    }
                }
            })
            .catch((error) => {
                dispatch(setLoaderAction(false));
                dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                setTimeout(() => {
                    dispatch(toastAction.showErrorMessage(false, ""));
                }, ERROR_TIMEOUT);
            });
    };

    
    export const resetIsOtpSend = (isOtpSendvalue) => (dispatch) => {
        dispatch(isOtpSend(isOtpSendvalue));
    }

    export const resetVerifyOtpData = () => (dispatch) => {
        dispatch(setVerifyOtpData(undefined));
    }


    export const changePassword = (authUserId,password) => (dispatch) => {
        dispatch(setLoaderAction(true));
        return apiServices
            .resetUserPassword(authUserId,password)
            .then(({ data }) => {
                if (data.isTransactionSucceed) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showSuccessMessage(true, data.successMessage));
                    dispatch(setVerifyOtpData(undefined)); 
                    setTimeout(() => {
                        dispatch(toastAction.showSuccessMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    if (data.errorMessage) {
                        dispatch(setLoaderAction(false));
                        dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                        setTimeout(() => {
                            dispatch(toastAction.showErrorMessage(false, ""));
                        }, ERROR_TIMEOUT);
                    } else {
                        dispatch(setLoaderAction(false));
                        dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                        setTimeout(() => {
                            dispatch(toastAction.showErrorMessage(false, ""));
                        }, ERROR_TIMEOUT);
                    }
                }
            })
            .catch((error) => {
                dispatch(setLoaderAction(false));
                dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                setTimeout(() => {
                    dispatch(toastAction.showErrorMessage(false, ""));
                }, ERROR_TIMEOUT);
            });
    };

